import { createEvent } from 'effector';

export const onResetStories = createEvent<void>('onResetStories');
export const onGetStories = createEvent<void>('onGetStories');
export const onToggleActiveItemStories = createEvent<any>('onToggleActiveItemStories');
export const onDeleteStories = createEvent<any>('onDeleteStories');
export const onSetStoriesItems = createEvent<Array<any>>('onSetStoriesItems');
export const onSortStoriesItems = createEvent<Array<any>>('onSortStoriesItems');
